import React, { useEffect, useMemo, useState } from "react";
import Accordion from "../../../../UI/Accordion";
import {
  Button,
  CarouselHeading,
  DividerContainer,
  DPImage,
  Header,
  LeftContainer,
  RightContainer,
  SlidePadding,
} from "../../../../styles/commonStyles";
import RadioGroup from "../../../../UI/RadioGroup";
import {
  APPROVE,
  APPROVE_REJECT_OPTIONS,
  PROFILE_TABS,
  REJECT,
  REJECTION_PREFIX_DEVICE_LINKAGES,
  TERMINATED_PROFILE_TAB,
} from "../../../../constants";
import DPCardCheckGroup from "../../../../UI/DPCardCheckGroup";
import Modal from "../../../../UI/Modal";
import Carousel from "../../../../UI/Carousel";
import DPImageSlideCheck from "../../../../UI/DPImageSlideCheck";
import Tabs from "../../../../UI/Tabs";
import styled from "styled-components";
import ConfirmationModal from "../../../../UI/ConfirmationModal";
import { getPath } from "../../../../../../utils";
import {
  approveQcDetails,
  getQcAdditionalData,
  getQcDetails,
  resetState,
  saveQcDetails,
  setQcDetails,
} from "../../../../../../store/actions/QcDetails";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  isActionDoneOnAllAboveSteps,
  isAnyStepRejected,
  isFieldEditable,
} from "../../../../utils/helper";
import { evaluatePerms, isEmpty } from "../../../../utils";
import { set } from "lodash-es";
import { ErrorText } from "../Step2";
import MenuNames from "../../../../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../../../../constants/Menu/MenuActionsMappings";

const qcWriteRole = MenuActionsMappings[MenuNames.QUALITY_CHECK_V2].WRITE;

const Step3 = ({
  qcDetails,
  handleSaveClick,
  initialState,
  setInitialState,
  getPhotoVerificationError,
  removePhotoVerificationError,
  allMenuActions,
  photoVerificationSteps,
  stepNum = 3,
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [radioValue, setRadioValue] = React.useState(null);
  const [modelOpen, setModelOpen] = React.useState(false);
  const [selectedIds, setSelectedIds] = React.useState([]);
  const [currTab, setCurrTab] = React.useState();
  const [visitedTerminatedTab, setVisitedTerminatedTab] = useState(false);
  const [confirmRejectOpen, setConfirmRejectOpen] = useState(false);
  const [confirmApproveOpen, setConfirmApproveOpen] = useState(false);
  const [currSlide, setCurrSlide] = useState(0);

  const isTerminated = qcDetails?.driver_lifecycle_status === "terminated";

  const driverDetails = qcDetails.basic_details?.driver_photo;

  const faceMatches = useMemo(() => {
    return getPath(
      qcDetails,
      "basic_details.device_linkages.device_linkage_data",
      []
    ).filter((dpData) =>
      currTab?.notPath
        ? currTab?.notPath !== dpData.lifecycle_status
        : currTab?.path === dpData.lifecycle_status
    );
  }, [qcDetails, currTab]);

  const deviceLinkageDetails = getPath(
    qcDetails,
    "basic_details.device_linkages",
    {}
  );
  const rejectionReason = getPath(
    qcDetails,
    "basic_details.device_linkages.rejection_reason",
    ""
  );
  const isAutoVerified = getPath(
    qcDetails,
    "basic_details.device_linkages.auto_verify",
    null
  );

  const rejectionFormItemId = "basic_details.device_linkages.rejection_reason";

  const actionHasBeenDone = !isEmpty(deviceLinkageDetails?.verified);

  useEffect(() => {
    if (currTab?.path === TERMINATED_PROFILE_TAB) {
      setVisitedTerminatedTab(true);
    }
  }, [currTab]);

  useEffect(() => {
    if (radioValue === APPROVE) {
      setSelectedIds([]);
    }
  }, [radioValue]);

  useEffect(() => {
    if (actionHasBeenDone) {
      const isRejected = !deviceLinkageDetails?.verified;
      setRadioValue(isRejected ? REJECT : APPROVE);

      if (isRejected) {
        const selectedIds = rejectionReason
          ?.replace(REJECTION_PREFIX_DEVICE_LINKAGES, "")
          ?.split(", ");

        setSelectedIds(selectedIds);
      }
    }
  }, [qcDetails]);

  const isRejected = radioValue === REJECT;

  const hasWritePermissions = evaluatePerms([qcWriteRole], allMenuActions);

  const isFormEditable =
    isFieldEditable("device_linkages", qcDetails) &&
    !isTerminated &&
    hasWritePermissions;

  const updateDriverPhoto = (newDetails) => {
    const newInitialState = JSON.parse(JSON.stringify(initialState));
    set(newInitialState, "basic_details.device_linkages", newDetails);
    setInitialState(newInitialState);
  };

  const handleRadioChange = (value) => {
    if (radioValue !== APPROVE && !visitedTerminatedTab && value === APPROVE)
      setConfirmApproveOpen(true);
    else {
      setRadioValue(value);

      const newDetails = getPath(initialState, "basic_details.device_linkages");
      newDetails.verified = value === APPROVE;

      if (value === APPROVE) {
        removePhotoVerificationError(rejectionFormItemId);
        newDetails.rejection_reason = null;
      }

      updateDriverPhoto(newDetails);
    }
  };

  const handleTerminateProfileRedirect = () => {
    setCurrTab(PROFILE_TABS[1]);
    setConfirmApproveOpen(false);
  };

  const stringifiedSelectedIds = selectedIds.map((id) => id).join(", ");

  const getRejectionReason = () => {
    if (selectedIds.length > 0) {
      return `${REJECTION_PREFIX_DEVICE_LINKAGES} ${stringifiedSelectedIds}`;
    } else {
      return rejectionReason;
    }
  };

  const anyStepsRejected = isAnyStepRejected(qcDetails, photoVerificationSteps);

  const actionDoneOnAboveSteps = isActionDoneOnAllAboveSteps(
    qcDetails,
    photoVerificationSteps,
    "device_linkages"
  );

  const isPhotoVerificationDone =
    getPath(qcDetails, "basic_details.driver_photo.verified", false) ||
    getPath(qcDetails, "basic_details.driver_photo.auto_verify", false);

  const getAccordionState = () => {
    if ((actionHasBeenDone && !anyStepsRejected) || isAutoVerified) {
      return deviceLinkageDetails?.verified || isAutoVerified
        ? "success"
        : "error";
    } else {
      return deviceLinkageDetails?.verified === false ? "error" : "default";
    }
  };

  const handleIdSelection = (ids) => {
    setSelectedIds(ids);

    const newDetails = getPath(initialState, "basic_details.device_linkages");
    newDetails.rejection_reason = `${REJECTION_PREFIX_DEVICE_LINKAGES} ${ids
      .map((id) => id)
      .join(", ")}`;

    if (!isEmpty(ids)) {
      removePhotoVerificationError(rejectionFormItemId);
    }

    updateDriverPhoto(newDetails);
  };

  const handleRejectClick = () => {
    handleSaveClick();
    setConfirmRejectOpen(false);
  };

  const handleCheckCardClick = (index) => {
    setModelOpen(true);
    setCurrSlide(index);
  };

  const rejectionFormItemError = getPhotoVerificationError(rejectionFormItemId);

  useEffect(() => {
    if (!isEmpty(rejectionFormItemError)) {
      setIsAccordionOpen(true);
    }
  }, [rejectionFormItemError]);

  useEffect(() => {
    if (
      !actionHasBeenDone &&
      !anyStepsRejected &&
      actionDoneOnAboveSteps &&
      !isAutoVerified &&
      !isTerminated
    ) {
      setIsAccordionOpen(true);
    } else {
      setIsAccordionOpen(false);
    }
  }, [
    actionHasBeenDone,
    isAutoVerified,
    anyStepsRejected,
    actionDoneOnAboveSteps,
  ]);

  return (
    <Accordion
      title={`Step ${stepNum}: Device ID check`}
      redBorder={!isEmpty(rejectionFormItemError)}
      isOpen={isAccordionOpen}
      setIsOpen={setIsAccordionOpen}
      state={getAccordionState()}
      disabled={
        !actionDoneOnAboveSteps ||
        anyStepsRejected ||
        isAutoVerified ||
        isTerminated ||
        !isPhotoVerificationDone
      }
      canOpen={
        actionDoneOnAboveSteps && !isAutoVerified && isPhotoVerificationDone
      }
    >
      <ConfirmationModal
        open={confirmRejectOpen}
        setOpen={setConfirmRejectOpen}
        image={driverDetails?.url}
        title="Reject photo"
        message="Are you sure you want to reject this photo?"
        subMessage="You cannot revert this step once rejected"
        primaryBtnText="Reject"
        onPrimaryBtnClick={handleRejectClick}
      />
      <ConfirmationModal
        open={confirmApproveOpen}
        setOpen={setConfirmApproveOpen}
        image={driverDetails?.url}
        title="Review terminated profiles"
        message="Terminated profiles have not been reviewed"
        subMessage="You cannot approve photo before checking terminated profile"
        primaryBtnText="Review terminated profiles"
        onPrimaryBtnClick={handleTerminateProfileRedirect}
        removeSecondaryBtn
      />
      <Modal
        open={modelOpen}
        setOpen={setModelOpen}
        title="Device linkages check"
        removePadding
      >
        <SlidePadding>
          <CarouselHeading>
            Select the photos that matches the uploaded photo:
          </CarouselHeading>
          <Carousel
            initialSlide={currSlide}
            slides={faceMatches.map((dpData) => (
              <DPImageSlideCheck
                dpData={dpData}
                uploadedImage={driverDetails?.url}
                onChange={handleIdSelection}
                value={selectedIds}
                key={dpData.id}
                showCheckbox={isRejected}
                disabled={!isFormEditable}
              />
            ))}
          />
          {selectedIds.length > 0 && (
            <SelectedIds>
              Selected face match ids - {stringifiedSelectedIds}
            </SelectedIds>
          )}
        </SlidePadding>
      </Modal>

      <DividerContainer>
        <LeftContainer>
          <Header>Uploaded photo</Header>
          <DPImage
            onClick={() => setModelOpen(true)}
            src={driverDetails?.url}
          />

          <RadioGroup
            value={radioValue}
            onChange={handleRadioChange}
            options={APPROVE_REJECT_OPTIONS}
            disabled={!isFormEditable}
          />
        </LeftContainer>
        <RightContainer>
          <Header bold>
            Select the photos that matches the uploaded photo:
          </Header>
          <TabWrapper>
            <Tabs
              noParams
              pillStyled
              tabs={PROFILE_TABS}
              currentTab={currTab}
              setCurrentTab={setCurrTab}
            />
          </TabWrapper>

          <DPCardCheckGroup
            data={faceMatches}
            onClick={handleCheckCardClick}
            onChange={handleIdSelection}
            value={selectedIds}
            showCheckbox={isRejected}
            disabled={!isFormEditable}
            id={rejectionFormItemId}
          />
        </RightContainer>
      </DividerContainer>
      <RejectionReasonContainer>
        {isEmpty(rejectionFormItemError) ? (
          radioValue !== APPROVE && (
            <RejectionReason>{getRejectionReason()}</RejectionReason>
          )
        ) : (
          <ErrorText>{rejectionFormItemError}</ErrorText>
        )}

        <StyledButton
          disabled={
            selectedIds.length === 0 ||
            !isFormEditable ||
            !isRejected ||
            !hasWritePermissions
          }
          onClick={() => setConfirmRejectOpen(true)}
        >
          Reject
        </StyledButton>
      </RejectionReasonContainer>
    </Accordion>
  );
};

export const SelectedIds = styled.div`
  padding: 20px;
  background: #fff0e9;
  border-radius: 16px;
  margin: 20px;
  margin-bottom: 0;
`;

export const StyledButton = styled(Button)`
  margin-left: auto;
`;

export const TabWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: flex-end;
`;

export const RejectionReasonContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 16px 20px;
  border-top: 1px solid #e0e0e0;
  width: 100%;
  justify-content: space-between;
`;

export const RejectionReason = styled.div`
  font-weight: 400;
  line-height: 24px;
  font-size: 18px !important;
`;

function mapStateToProps(state) {
  const { QcDetails, MenuActions } = state;
  return {
    qcDetails: QcDetails.qcDetails,
    currentActiveFeId: QcDetails.currentActiveFeId,
    qcRejectionReasons: QcDetails.qcRejectionReasons,
    qcDocTypes: QcDetails.qcDocTypes,
    allMenuActions: MenuActions.allMenuActions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getQcDetails: bindActionCreators(getQcDetails, dispatch),
    getQcAdditionalData: bindActionCreators(getQcAdditionalData, dispatch),
    saveQcDetails: bindActionCreators(saveQcDetails, dispatch),
    approveQcDetails: bindActionCreators(approveQcDetails, dispatch),
    setQcDetails: bindActionCreators(setQcDetails, dispatch),
    resetState: bindActionCreators(resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Step3);
